// extracted by mini-css-extract-plugin
module.exports = {"header":"PricingPage_header__rcqMe","mark":"PricingPage_mark__QpxSP"};